<template>
    <pagination centered class="mb-2" :visible="visible" :links="links" :meta="meta" @change-page:clicked="(link) => $emit('change-page:clicked', link)" />
</template>

<script setup>
import Pagination from './Pagination.vue'

defineProps({
    visible: { type: Boolean, default: false },
    links: { type: Object, required: true },
    meta: { type: Object, required: true },
})

defineEmits(['change-page:clicked'])
</script>
